import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { ModalityOrbit } from './ModalityOrbit';
import { orbitNodes } from '../../data/modalities';
const fade = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      delay: index * 0.08,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};
export function Hero() {
  return <section className="relative w-full max-w-[100vw] overflow-hidden bg-white" data-id="element-374" data-mp="375qxc02khghv">
      <img src="https://cdn.magicpatterns.com/uploads/jcxmq9exrVrKEqcEaZF8dP/jag-hero-balanced-room-v3.png" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover object-[72%_center] opacity-[0.34] sm:opacity-[0.44] lg:opacity-[0.78]" data-id="element-375" data-mp="3c3iqsyiv1ao6" />
      <div className="pointer-events-none absolute inset-0 bg-white/68 sm:bg-white/60 lg:bg-white/24" data-id="element-376" data-mp="1ms8jwee8ci1t" />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-full bg-white/58 sm:bg-white/52 lg:w-[54%] lg:bg-white/82" data-id="element-377" data-mp="1qttu1rzdqi8b" />
      <div className="relative mx-auto grid w-full max-w-[100vw] items-center gap-10 px-5 py-14 sm:max-w-7xl sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:py-20" data-id="element-378" data-mp="1y7c0t68wjk5o">
        <div className="w-full min-w-0 max-w-xs sm:max-w-xl" data-id="element-379" data-mp="1t928d3ekaxnr">
          <motion.p variants={fade} initial="hidden" animate="show" custom={0} className="w-full min-w-0 max-w-xs whitespace-normal break-words text-[11px] font-semibold uppercase tracking-[0.08em] text-teal sm:max-w-xl sm:text-[12px] sm:tracking-[0.16em] lg:text-[13px] xl:text-[14px]" data-id="element-380" data-mp="1oaqw6m0sob2d">
            <span className="block" data-id="element-381" data-mp="27077m4e0pnxk">Equipment Guidance for Rehabilitation</span>
            <span className="block" data-id="element-382" data-mp="2729voivm16zn">and Wellness Practices</span>
          </motion.p>
          <motion.h1 variants={fade} initial="hidden" animate="show" custom={1} className="mt-4 w-full min-w-0 max-w-xs whitespace-normal break-words font-display text-[1.6rem] font-extrabold leading-[1.08] tracking-tight text-navy sm:max-w-xl sm:text-5xl sm:leading-[1.05] lg:text-[3.75rem] xl:text-[4rem]" data-id="element-383" data-mp="10leoxrp12d2p">
            Curated Modality Solutions for Your Practice
          </motion.h1>
          <motion.p variants={fade} initial="hidden" animate="show" custom={2} className="mt-6 w-full min-w-0 max-w-xs whitespace-normal break-words text-[17px] leading-relaxed text-charcoal/75 sm:max-w-xl lg:text-[18px] xl:text-[19px] xl:leading-[1.65]" data-id="element-384" data-mp="3er35q1rr06pz">
            JAG Medical Solutions helps chiropractors, physical therapists, and
            wellness practices compare proven technologies. As a trusted
            partner, our mission is to help you choose the equipment that suits
            your clinic&apos;s workflow and provides the best patient outcomes.
          </motion.p>
          <motion.div variants={fade} initial="hidden" animate="show" custom={3} className="mt-8 w-full max-w-xs sm:w-auto sm:max-w-none" data-id="element-385" data-mp="2m51mjqb4f4n9">
            <a href="#products" className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-7 py-3.5 text-[15px] font-semibold text-navy transition-colors hover:border-teal hover:text-teal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 sm:w-auto" data-id="element-386" data-mp="2cfl940551fne">
              Explore Product Categories
              <ArrowRightIcon className="h-[18px] w-[18px]" data-id="element-387" data-mp="2v518gk537228" />
            </a>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="hidden justify-center lg:flex" data-id="element-388" data-mp="2q8atk050qcie">
          <ModalityOrbit data-id="element-389" data-mp="12gtkekseanos" />
        </motion.div>

        <div className="grid w-full min-w-0 max-w-xs grid-cols-1 gap-3 sm:max-w-none sm:grid-cols-2 lg:hidden" data-id="element-390" data-mp="12fs5u6c67j2b">
          {orbitNodes.map(node => <div key={node.id} className="min-w-0 rounded-2xl border border-slate-100 bg-white/95 p-4 shadow-sm" data-id="element-391" data-mp="1c7o71q9jzpar">
              <p className="break-words font-display text-sm font-bold leading-tight text-navy" data-id="element-392" data-mp="em0mq3qdgxfl">
                {node.name}
              </p>
              <p className="mt-1.5 break-words text-xs leading-snug text-charcoal/55" data-id="element-393" data-mp="ohkf4g5q9dzl">
                {node.detail}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}